import { render, staticRenderFns } from "./OAChildren.vue?vue&type=template&id=e401152e"
import script from "./OAChildren.vue?vue&type=script&lang=js"
export * from "./OAChildren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports